import {
  Combobox,
  DropdownButton,
  Icons,
  NoOptionsPlaceholder
} from '@eggplant/pattern-library'
import type {
  ButtonShape,
  DropdownPlacement,
  GetGitRefsResponse,
  Options,
  Placement
} from '@eggplant/types'
import { GIT_REFERENCE } from './constants'

interface Props {
  gitRefs: GetGitRefsResponse
  isDisabled?: boolean
  onChange: (value: string) => void
  placeholder?: string
  value?: string
  placement?: Placement
  dropdownPlacement?: DropdownPlacement
  isFilterFixedMinMaxWidth?: boolean
  isFilter?: boolean
}

interface labelValue {
  label: string
  value: string
}

const getOptions = ({ branches }: GetGitRefsResponse) => branches.length > 0
  ? branches.map(item => ({
    label: item.name.split('/').at(-1),
    value: item.ref
  }) as labelValue)
  : []

const SelectGitReference = ({
  gitRefs,
  isDisabled,
  onChange,
  placeholder = 'Git reference',
  value,
  dropdownPlacement = 'bottom',
  placement,
  isFilterFixedMinMaxWidth = true,
  isFilter = false
}: Props) => {
  const options = getOptions(gitRefs)

  // eslint-disable-next-line complexity
  const renderButton = (options: Options) => {
    const currentOption = value
      ? options.find(item => item.value.includes(value))
      : undefined

    const label = currentOption?.value
      ? currentOption.label
      : placeholder

    const repositoryTooltip = [GIT_REFERENCE].includes(String(value))
      ? label
      : `Git reference: ${label}`

    const tooltip = currentOption?.value
      ? repositoryTooltip
      : placeholder

    const buttonText = currentOption?.value
      ? currentOption.label
      : placeholder

    return (buttonProps: ButtonShape) =>
      <DropdownButton
        {...buttonProps}
        Icon={Icons.GitReference}
        dropdownPlacement={dropdownPlacement}
        isDisabled={isDisabled}
        isFilter={isFilter}
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        isHighlighted={!!value}
        label={label}
        placement={placement}
        title={tooltip}
      >
        {buttonText}
      </DropdownButton>
  }

  const noDataPlaceholder =
    <NoOptionsPlaceholder
      icon={<Icons.GitReference size='24px' />}
      title='No Git reference found'
    />

  return (
    <Combobox
      dropdownPlacement={dropdownPlacement}
      isFilter={isFilter}
      isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
      noOptionsPlaceholder={noDataPlaceholder}
      onChange={onChange}
      options={options}
      placement={placement}
      renderButton={renderButton(options)}
      value={value}
    />
  )
}

export default SelectGitReference

